// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"RegistrationForm_formWrapper__YSELe","loginForm":"RegistrationForm_loginForm__1lmrG"};